import React from 'react';
import { FadeIn } from '../ui/FadeIn';
import { Divider } from '../ui/Divider';
export function Hook() {
  return <section className="py-16 px-6 bg-white" data-id="element-58">
      <div className="max-w-3xl mx-auto" data-id="element-59">
        <FadeIn data-id="element-60">
          <div className="text-2xl md:text-3xl font-serif italic text-brand-brown leading-relaxed text-center" data-id="element-61">
            "Son las 6:00 AM. Abres los ojos y, antes de levantarte, ya sientes
            ese peso. Intentas cerrar el puño y tus dedos se sienten rígidos,
            como madera seca. Al poner los pies en el suelo, el pinchazo en la
            rodilla o el dolor en la cadera te obligan a caminar despacio,
            apoyándote en los muebles."
          </div>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-62">
          <p className="mt-8 text-lg md:text-xl text-center" data-id="element-63">
            Te han dicho que "es la edad" y que debes acostumbrarte. Pero el
            dolor no es un castigo por cumplir años; es un{' '}
            <strong data-id="element-64">incendio interno</strong> que nadie te ha enseñado a apagar
            correctamente.
          </p>
        </FadeIn>

        <Divider data-id="element-65" />
      </div>
    </section>;
}